/**
 * Medication charting entry DTOs (MAR - Medication Administration Record)
 * Extracted from src/services/patientmr/charting.service.ts
 */

import { BaseEntryData } from './chart-entry.dto';

/** Phase 18 M7 */
export const MAR_STATUSES = ['GIVEN', 'HELD', 'REFUSED', 'NOT_GIVEN'] as const;
export type MarStatus = typeof MAR_STATUSES[number];

export const MAR_WITHHOLD_REASONS = ['NPO', 'VOMITING', 'PARAMETER', 'MD_ORDER', 'REFUSED', 'UNAVAILABLE', 'OTHER'] as const;
export type MarWithholdReason = typeof MAR_WITHHOLD_REASONS[number];

export const MAR_EFFECTIVENESS = ['EFFECTIVE', 'PARTIAL', 'NOT_EFFECTIVE'] as const;
export type MarEffectiveness = typeof MAR_EFFECTIVENESS[number];

/**
 * Medication administration data structure
 */
export interface MedicationData extends BaseEntryData {
  /** MED-03: id of the medication on the patient's list (absent when typed in) */
  medicationId?: string;
  notOnMedList?: boolean;
  medicationName: string;
  dose?: string;
  route?: string;
  site?: string;
  reaction?: string;
  /** Phase 18 M7: default GIVEN */
  status?: MarStatus;
  /** Required unless GIVEN; OTHER needs notes */
  withholdReason?: MarWithholdReason | null;
  /** Required when the medication on the list is PRN */
  indication?: string;
  /** Follow-up of a PRN GIVEN entry in the same visit */
  effectiveness?: MarEffectiveness;
  followUpOf?: string;
  administrationTime?: string;
  notes?: string;
}
